import { useTranslation } from 'react-i18next';
import SectionTitle from './SectionTitle';

const About = ({ id }) => {
  const { t } = useTranslation();

  return (
    <section id={id} className="py-20 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto transition-colors duration-200" style={{backgroundColor: 'var(--background)', color: 'var(--foreground)'}}>
      <SectionTitle
        title={t('about.title')}
        coloredTitle={t('about.coloredTitle')}
      />

      <div className="flex flex-col md:flex-row items-center">
        <div className="md:w-1/3 mb-10 md:mb-0 flex justify-center">
          <div className="w-64 h-64 rounded-full overflow-hidden border-4 shadow-lg" style={{borderColor: 'var(--border)'}}>
            <div className="w-full h-full bg-gray-200 flex items-center justify-center">
              <img src="https://s.gravatar.com/avatar/5d494a162fd7d534b1e599afb2575e21?s=480&r=pg&d=https%3A%2F%2Fcdn.auth0.com%2Favatars%2Fwo.png" alt="ismaildev"/>
            </div>
          </div>
        </div>
        <div className="md:w-2/3 md:pl-12">
          <h3 className="text-2xl font-semibold mb-4" style={{color: 'var(--foreground)'}}>{t('about.heading.whoAmI')}</h3>
          <p className="mb-6" style={{color: 'var(--muted-foreground)'}}>
            {t('about.description.paragraph1')}
          </p>
          <p className="mb-6" style={{color: 'var(--muted-foreground)'}}>
            {t('about.description.paragraph2')}
          </p>
          <div className="grid grid-cols-2 gap-4 mb-6">
            <div>
              <p className="font-medium" style={{color: 'var(--foreground)'}}>{t('common.labels.name')}: <span style={{color: 'var(--muted-foreground)'}}>{t('about.info.name')}</span></p>
              <p className="font-medium" style={{color: 'var(--foreground)'}}>{t('common.labels.email')}: <span style={{color: 'var(--muted-foreground)'}}>{t('about.info.email')}</span></p>
            </div>
            <div>
              <p className="font-medium" style={{color: 'var(--foreground)'}}>{t('common.labels.from')}: <span style={{color: 'var(--muted-foreground)'}}>{t('about.info.from')}</span></p>
              <p className="font-medium" style={{color: 'var(--foreground)'}}>{t('common.labels.freelance')}: <span style={{color: 'var(--muted-foreground)'}}>{t('about.info.freelanceStatus')}</span></p>
            </div>
          </div>
          <a href="https://docs.google.com/document/d/1Uma_oeWn-0Sz-2I_C243Cr6K1x9xZXOP0-ic1GIxtTk/edit?usp=sharing" target="_blank" className="inline-block px-6 py-3 bg-gradient-to-r from-blue-500 to-purple-600 text-white rounded-lg font-medium hover:opacity-90 transition duration-300">
            {t('common.cta.showCV')}
          </a>
        </div>
      </div>
    </section>
  );
};

export default About;
